export default __webpack_public_path__ + "static/media/photo11.5443fb44.jpeg";